export default __webpack_public_path__ + "static/media/groups.7b0d02f9.svg";